import CryptoJS from "crypto-js";
import { Logger } from "../logger";
import { AppConfig } from "../../AppConfig";

export interface ILocalStorageManager {
  saveObject<T>(key: string, object: T): void;
  getObject<T>(key: string): T | null;
  removeObject(key: string): void;
}

export class LocalStorageManager implements ILocalStorageManager {
  private static _instance: ILocalStorageManager;
  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  /**
   * Retrieve an object by giving a key
   * @param key
   */
  getObject<T>(key: string): T | null {
    try {
      const hash = localStorage.getItem(key);
      if (hash) {
        const decipher = CryptoJS.AES.decrypt(
          hash,
          process.env.NODE_ENV === "test"
            ? ""
            : (process.env.REACT_APP_SECRET as string),
        );
        if (process.env.NODE_ENV === "development") {
          return JSON.parse(hash) as T;
        } else {
          return JSON.parse(decipher.toString(CryptoJS.enc.Utf8)) as T;
        }
      }
    } catch (e) {
      Logger.getInstance().error(String(e));
    }
    return null;
  }

  /**
   * Save an object with a key
   * @param key
   * @param object
   */
  saveObject<T>(key: string, object: T): void {
    try {
      const str = CryptoJS.AES.encrypt(
        JSON.stringify(object),
        process.env.NODE_ENV === "test"
          ? ""
          : (process.env.REACT_APP_SECRET as string),
      );
      if (process.env.NODE_ENV === "development") {
        localStorage.setItem(key, JSON.stringify(object));
      } else {
        localStorage.setItem(key, str.toString());
      }
      if (key === AppConfig.Instance.LocalStorageKey.accessToken) {
        localStorage.setItem(
          AppConfig.Instance.CallbackTokenKey,
          JSON.stringify({ token: object }),
        );
      }
    } catch (e) {
      Logger.getInstance().error(String(e));
    }
  }

  /**
   * Remove an object by giving a key
   * @param key
   */
  removeObject(key: string) {
    try {
      localStorage.removeItem(key);
      if (key === AppConfig.Instance.LocalStorageKey.accessToken) {
        localStorage.removeItem(AppConfig.Instance.CallbackTokenKey);
      }
    } catch (e) {
      Logger.getInstance().error(String(e));
    }
  }
}
